import { toastr } from 'react-redux-toastr';
import adminRestoreDeletedBooking from './adminRestoreDeletedBooking.gql';
import {
  RESTORE_BOOKING_ERROR,
  RESTORE_BOOKING_SUCCESS,
  RESTORE_BOOKING_START
} from '../../../constants';

export default function restoreDeletedBooking(orderId) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: RESTORE_BOOKING_START
    });

    try {
      let errorMessage;

      const mutation = adminRestoreDeletedBooking;

      const { data } = await client.mutate({
        mutation,
        variables: {
          orderId
        }
      });

      if (data?.adminRestoreDeletedBooking?.status === 200) {
        dispatch({
          type: RESTORE_BOOKING_SUCCESS
        });
        toastr.success('Success', `The booking has been restored.`);
        return {
          status: 200
        };
      } else {
        dispatch({
          type: RESTORE_BOOKING_ERROR
        });

        errorMessage = (data?.adminRestoreDeletedBooking?.errorMessage) || "Oops! Something went wrong. Please try again.";
        toastr.error('Error!', errorMessage);
        return {
          status: 400
        };
      }
    } catch (err) {
      toastr.error('Error!', err);
      dispatch({
        type: RESTORE_BOOKING_ERROR
      });
      return {
        status: 400
      };
    }

  }
};